import type { Messages } from './en.ts';

export const ko: Messages = {
  'nav.dashboard': '대시보드',
  'nav.stake': '스테이킹',
  'nav.bond': '본드',
  'nav.swap': '스왑',
  'nav.liquidity': '유동성',
  'nav.referral': '추천',
  'nav.docs': '문서',
  'nav.admin': '관리',
  'nav.more': '더보기',
  'wallet.connect': '지갑 연결',
  'wallet.choose': '지갑 선택',
  'wallet.disconnect': '연결 해제',
  'wallet.copy': '주소 복사',
  'wallet.copied': '복사됨',
  'wallet.none': '지갑을 찾을 수 없습니다. MetaMask, Trust Wallet, Binance Wallet, OKX Wallet 등의 확장 프로그램을 설치하거나 지갑 앱에서 이 페이지를 여세요.',
  'wallet.walletconnect': 'WalletConnect (모바일 지갑, Binance Wallet, Safe 등 300개 이상)',
  'wallet.openIn': '{wallet}에서 열기',
  'wallet.mobileHint': '휴대폰에서는 지갑 앱 안에서 이 페이지를 열거나, WalletConnect로 원하는 지갑을 연결하세요.',
  'wallet.safety': '연결 시 공유되는 것은 주소뿐입니다. 모든 거래는 서명 전에 지갑에 표시됩니다.',
  'network.wrong': '잘못된 네트워크',
  'network.switch': '{chain}(으)로 전환',
  'common.close': '닫기',
  'common.max': '최대',
  'common.balance': '잔액',
  'common.approve': '{token} 승인',
  'common.confirmInWallet': '지갑에서 확인하세요…',
  'common.pending': '확인 대기 중…',
  'common.done': '완료',
  'common.viewTx': '거래 보기',
  'common.connectFirst': '계속하려면 지갑을 연결하세요',
  'common.enterAmount': '수량 입력',
  'common.insufficient': '{token} 잔액이 부족합니다',
  'common.loading': '불러오는 중…',
  'common.notAdvice': '이율, ROI, APY는 현재 파라미터로 계산되며 변동됩니다. 미래 수익을 약속하지 않습니다.',
  'page.dashboard.title': '대시보드',
  'page.stake.title': '스테이킹',
  'page.bond.title': '본드',
  'page.swap.title': '스왑',
  'page.liquidity.title': '유동성',
  'page.referral.title': '추천',
  'page.docs.title': '문서',
  'page.admin.title': '관리',
  'dash.eyebrow': '프로토콜',
  'dash.title': '개요',
  'dash.price': 'SYN 가격',
  'dash.priceSub': '30분 TWAP · 현재가 {spot}',
  'dash.marketCap': '시가총액',
  'dash.treasury': '트레저리 (무위험)',
  'dash.treasurySub': '트레저리 보유 USDT + BNB + LP',
  'dash.backing': 'SYN당 담보',
  'dash.staked': '스테이킹 비율',
  'dash.stakedSub': '총 공급량 대비',
  'dash.apySub': '12시간 에포크당 {rate}',
  'dash.index': 'sSYN 인덱스',
  'dash.nextRebase': '다음 리베이스',
  'dash.runway': '런웨이',
  'dash.runwayDays': '{n}일',
  'dash.runwaySub': '트레저리 ÷ 일일 보상 가치',
  'dash.mcapVsBacking': '시가총액 대비 트레저리 담보',
  'dash.premium': '시장은 SYN을 트레저리 담보의 {x}배로 평가합니다.',
  'dash.yourPosition': '내 포지션',
  'dash.wallet': '지갑 보유',
  'dash.bonds': '본드',
  'dash.bondCount': '{n}건',
  'dash.referral': '청구 가능한 추천 보상',
  'dash.how': '작동 방식',
  'dash.how1': 'BNB, USDT, SYN-USDT LP로 본드를 구매해 시장가보다 낮게 SYN을 받습니다. 7일 후 전액 잠금 해제됩니다.',
  'dash.how2': 'SYN을 잠금 없음부터 영구 잠금까지 6가지 플랜으로 스테이크할 수 있습니다. 모든 플랜이 12시간마다 복리로 늘어납니다.',
  'dash.how3': '보상은 에포크별 한도 내에서 새로 발행됩니다. 본드 대금은 트레저리를 쌓고, 급락 시 SYN을 되삽니다.',
  'dash.how4': '친구 초대: 직접 추천인의 스테이킹 보상 5%와 약한 쪽 레그에 대한 등급별 보상을 스테이킹 금액의 300%까지 받습니다.',
  'stake.eyebrow': '스테이킹',
  'stake.title': 'SYN 스테이킹',
  'stake.amount': '스테이킹 수량',
  'stake.fee': '스테이킹 수수료 ({pct})',
  'stake.youGet': '받는 수량',
  'stake.unlocks': '잠금 해제',
  'stake.exitFee': '언스테이킹 수수료',
  'stake.exitFeeNote': '스테이킹에서 꺼내는 모든 금액의 {pct}',
  'stake.principal': '원금으로 계산',
  'stake.cta': '스테이크 ({plan})',
  'stake.positions': '내 스테이크',
  'stake.noLots': '아직 스테이크가 없습니다.',
  'stake.lockedUntil': '잠김',
  'stake.withdrawn': '출금됨',
  'stake.withdraw': '출금',
  'stake.youReceiveNet': '{pct} 수수료 후 {amount} SYN을 받습니다',
  'stake.projection': '예상',
  'stake.projectionNote': '현재 이율이 기간 내내 유지된다고 가정했습니다. 이율은 에포크마다 바뀌며, 보상 예산에 따라 낮아질 수 있습니다.',
  'stake.after': '{period} 후',
  'stake.d30': '30일',
  'stake.d90': '90일',
  'stake.d365': '1년',
  'stake.nothingPending': '아직 미청구 보상이 없습니다',
  'common.approved': '{token} 승인 완료',
  'bond.eyebrow': '본드',
  'bond.title': '시장가보다 싸게 SYN 구매',
  'bond.price': 'SYN 가격',
  'bond.treasury': '트레저리',
  'bond.open': '열린 마켓',
  'bond.openOf': '{m}개 중 {n}개',
  'bond.outstanding': '미지급 지급액',
  'bond.outstandingSub': '모든 본드에서 베스팅 중인 SYN',
  'bond.markets': '본드 마켓',
  'bond.asset': '자산',
  'bond.bondPrice': '본드 가격',
  'bond.roi': 'ROI',
  'bond.discount': '할인',
  'bond.capacity': '남은 용량',
  'bond.vesting': '베스팅',
  'bond.days7': '7일 (일괄 해제)',
  'bond.closed': '마감',
  'bond.select': '본드',
  'bond.form': '{asset}로 본드',
  'bond.pay': '지불',
  'bond.value': '가치',
  'bond.receive': '받는 수량',
  'bond.unlock': '전액 해제',
  'bond.feeNote': '지불액의 15%는 수수료 지갑으로, 85%는 트레저리로 갑니다. 둘 다 가격에 포함되어 있습니다.',
  'bond.slippage': '허용 가격 변동',
  'bond.minReceive': '최소 수령액',
  'bond.cta': '본드',
  'bond.overMax': '본드 1회 최대 {amount}',
  'bond.overCap': '이번 기간 남은 양은 {amount}뿐입니다',
  'bond.soldOut': '이번 기간 매진',
  'bond.maxPer': '1회 최대',
  'bond.leftNow': '이번 기간 남은 양',
  'bond.limitVal': '{payout} SYN ≈ {amount}',
  'bond.paused': '본드 일시 중지 중',
  'bond.pausedTitle': '본드가 일시 중지되었습니다. ',
  'bond.pausedWhy': '풀 가격({spot})이 30분 평균({twap})과 {dev} 차이 납니다. 가격 조작을 막기 위해 본드는 두 가격 차이가 {max} 이내일 때만 열립니다. 평균이 따라오면 자동으로 다시 열립니다(보통 30분 이내, 가격이 돌아오면 더 빨리). 스테이킹, 스왑, 청구는 계속 사용할 수 있습니다.',
  'bond.roiExplain': 'ROI는 본드 해제 시 현재 시장가로 얻는 이익입니다. 마켓 판매가 늘면 낮아지고 시간이 지나면 회복됩니다.',
  'bond.positions': '내 본드',
  'bond.chainId': '컨트랙트상 본드 ID {id}',
  'bond.none': '아직 본드가 없습니다.',
  'bond.payout': '지급액',
  'bond.market': '마켓',
  'bond.status': '상태',
  'bond.vestingStatus': '베스팅 중',
  'bond.claimable': '청구 가능',
  'bond.claimed': '청구 완료',
  'bond.claimAll': '{n}건 청구',
  'bond.claimStake': '{n}건 청구 후 스테이킹',
  'bond.into': '스테이킹 대상',
  'bond.claimableTotal': '청구 가능 {amount} SYN',
  'swap.eyebrow': 'PancakeSwap V2',
  'swap.title': '스왑',
  'swap.pay': '지불',
  'swap.receive': '받는 수량 (예상)',
  'swap.flip': '방향 전환',
  'swap.rate': '환율',
  'swap.minReceived': '최소 수령액',
  'swap.impact': '가격 영향',
  'swap.route': '경로',
  'swap.fee': '풀 수수료',
  'swap.slippage': '슬리피지 허용',
  'swap.cta': '스왑',
  'swap.highImpact': '가격 영향이 큽니다: 현재 가격보다 {pct} 불리한 비율로 거래됩니다. 더 적은 수량을 고려하세요.',
  'swap.noRoute': '이 페어의 풀이 없습니다',
  'swap.noTax': 'SYN에는 전송세가 없습니다. 풀 수수료와 가격 영향만 적용됩니다.',
  'swap.pool': 'SYN-USDT 풀',
  'swap.reserves': '리저브',
  'swap.tvl': '풀 가치',
  'liq.eyebrow': 'PancakeSwap V2',
  'liq.title': 'SYN-USDT 유동성',
  'liq.add': '추가',
  'liq.remove': '제거',
  'liq.first': '풀의 현재 비율로 두 토큰을 예치합니다. 지분만큼 LP 토큰을 받고, 모든 스왑 수수료가 풀에 쌓입니다.',
  'liq.share': '추가 후 지분',
  'liq.slippage': '최대 슬리피지',
  'liq.noLp': '이 풀의 LP 토큰이 아직 없습니다. 먼저 유동성을 추가하세요.',
  'liq.lpOut': '받는 LP 토큰',
  'liq.ctaAdd': '유동성 추가',
  'liq.removeAmount': '제거할 LP 토큰',
  'liq.youGet': '받는 수량',
  'liq.ctaRemove': '유동성 제거',
  'liq.position': '내 포지션',
  'liq.lpBalance': 'LP 토큰',
  'liq.poolShare': '풀 지분',
  'liq.underlying': '구성',
  'liq.bondIt': 'LP 토큰은 SYN-USDT LP 마켓에서 할인 본드로 사용할 수 있습니다.',
  'liq.goBond': '본드로 이동',
  'liq.risk': '유동성 공급에는 비영구적 손실, 슬리피지, 스마트 컨트랙트 위험이 있습니다.',
  'ref.eyebrow': '바이너리 트리',
  'ref.title': '추천',
  'ref.rank': '등급',
  'ref.left': '왼쪽 레그 (활성)',
  'ref.right': '오른쪽 레그 (활성)',
  'ref.matched': '매칭 (약한 쪽)',
  'ref.claimable': '청구 가능',
  'ref.direct': '직접 추천',
  'ref.directSub': '그들의 스테이킹 보상의 {bps}',
  'ref.cap': '추천 한도',
  'ref.capUsed': '{cap} 중 {used} 사용',
  'ref.capNote': '추천 보상과 출금한 원금은 최고 활성 스테이킹의 300%에 포함됩니다. 더 스테이킹하면 한도가 올라갑니다.',
  'ref.inviteTitle': '초대 링크',
  'ref.inviteAbout': '새 회원은 선택한 쪽에 가입하고, 첫 스테이크와 함께 그쪽의 가장 바깥 빈자리에 배치됩니다. 초대한 모든 사람에게서 직접 보너스를, 약한 쪽 레그에서 바이너리 보상을 받습니다.',
  'ref.placeLeft': '왼쪽',
  'ref.placeRight': '오른쪽',
  'ref.copy': '링크 복사',
  'ref.copied': '복사됨',
  'ref.yourCode': '내 초대 코드',
  'ref.codeNote': '내 지갑 {address}에 연결되어 있습니다. 코드는 회원에게만 있으므로 지어낸 코드는 작동하지 않습니다.',
  'ref.copyCode': '코드 복사',
  'ref.sponsorHint': '예: K7Q2M9XA 또는 0x…',
  'ref.lookingUp': '초대 코드를 확인하는 중…',
  'ref.codeUnknown': '이 초대 코드를 가진 회원이 없습니다',
  'ref.lookupFailed': '지금은 코드를 확인할 수 없습니다. 추천인 주소를 붙여넣으세요',
  'ref.needStake': '초대 링크를 받으려면 SYN을 스테이킹 (또는 추천인 연결) 하세요.',
  'ref.bindTitle': '추천인 아래로 가입',
  'ref.bindAbout': '가입은 영구적이며 첫 스테이킹 전에 해야 합니다. 그렇지 않으면 프로젝트 아래에 배치됩니다. 트리의 자리는 첫 스테이크와 함께 정해집니다.',
  'ref.sponsor': '초대 코드 또는 추천인 주소',
  'ref.side': '방향',
  'ref.sideHint': '초대한 사람이 내 두 팀 중 어느 팀에 들어갈지 정합니다. 바이너리 보상은 작은 팀 기준으로 지급되고 랭크에는 두 팀이 모두 필요하므로 양쪽을 함께 키우세요.',
  'ref.sideHintJoin': '추천인의 두 팀 중 어느 팀에 들어갈지 정합니다. 링크에서 이미 선택되어 있지만 연결 전에 바꿀 수 있습니다.',
  'join.invited': '{sponsor} 님(코드 {code}, {side} 팀)에게 초대받았습니다. 지금 그 팀에 참여하세요. 트리의 자리는 첫 스테이크와 함께 정해집니다. 참여하지 않고 스테이크하면 프로젝트의 기본 추천인 아래에 영구히 배치됩니다.',
  'join.cta': '추천인 팀에 참여',
  'join.left': '왼쪽',
  'join.right': '오른쪽',
  'join.none': '아직 추천 팀에 참여하지 않았습니다. 이대로 스테이크하면 프로젝트의 기본 추천인 아래에 영구히 배치됩니다. 초대를 받았다면 먼저 초대 링크를 여세요.',
  'ref.bindCta': '추천인 연결',
  'ref.badAddress': '초대 코드 또는 지갑 주소를 입력하세요',
  'ref.sponsorUnknown': '이 추천인은 아직 가입하지 않았습니다',
  'ref.sponsorOk': '추천인 확인됨: {address}',
  'ref.bound': '내 추천인',
  'ref.placedUnder': '{parent}의 {side}에 배치',
  'ref.notPlacedYet': '트리의 자리는 첫 스테이크와 함께 정해집니다',
  'ref.teamTitle': '내 팀',
  'ref.teamPlaced': '팀에 배치됨',
  'ref.teamPending': '가입했지만 아직 스테이크 전',
  'ref.teamEmpty': '아직 내 링크로 가입한 사람이 없습니다.',
  'ref.teamPendingNote': '첫 스테이크와 함께 팀의 자리를 갖게 됩니다.',
  'ref.teamMember': '회원',
  'ref.teamSide': '쪽',
  'ref.teamStake': '활성 스테이크',
  'ref.ladder': '등급',
  'ref.ladderNote': '등급에는 두 레그에 동시에 스테이크된 금액의 합계와 각 쪽에 최소 {pct}가 필요합니다. 한 번 달성한 등급은 영구적입니다.',
  'ref.member': '멤버',
  'ref.bronze': '브론즈',
  'ref.silver': '실버',
  'ref.gold': '골드',
  'ref.diamond': '다이아몬드',
  'ref.crown': '크라운',
  'ref.rate': '바이너리 이율',
  'ref.needs': '조건',
  'ref.total': '합계',
  'ref.weaker': '약한 쪽',
  'ref.reached': '달성',
  'ref.tree': '내 트리',
  'ref.treeAbout': '회원을 누르면 그 아래 트리를 봅니다.',
  'ref.you': '나',
  'ref.legendLeft': '왼쪽 팀',
  'ref.legendRight': '오른쪽 팀',
  'ref.openSlot': '빈 자리',
  'ref.legendFlow': '활성 스테이크는 위로 합산됩니다',
  'ref.back': '나에게 돌아가기',
  'ref.own': '본인 스테이킹',
  'ref.claimTitle': '추천 보상 청구',
  'ref.claimAbout': '30분 평균 가격으로 새로 발행된 SYN으로 지급됩니다. 활성 스테이킹이 필요합니다.',
  'ref.approx': '≈ {amount} SYN',
  'ref.claimCta': '청구',
  'ref.notEligible': '추천 보상을 청구하려면 SYN을 스테이킹하세요',
  'docs.eyebrow': '가이드',
  'docs.title': 'Syntra 작동 방식',
  'docs.bondH': '본드',
  'docs.bondP': 'BNB, USDT, SYN-USDT LP로 지불하고 현재 가격 기준 지불액보다 가치가 큰 SYN을 받습니다 (ROI). 지급액은 구매 후 정확히 7일 뒤 전액 해제되며, 구매마다 따로 진행됩니다. 지불액의 15%는 수수료 지갑으로, 85%는 트레저리로 갑니다.',
  'docs.stakeH': '스테이킹',
  'docs.stakeP': '6가지 플랜이 있으며 모두 12시간마다 복리로 늘어납니다. 잠금 없음(언제든 출금 가능, SYN ↔ sSYN 변환과 동일), 30·90·180·365일 잠금(잠금이 끝나면 출금할 수 있고 잠금 없음 이율로 계속 복리), 영구 잠금(원금은 출금할 수 없지만 보상은 언제든 출금 가능). 보상은 새로 발행되며 에포크당 상한이 있습니다.',
  'docs.refH': '추천',
  'docs.refP': '초대한 모든 사람의 스테이킹 보상의 {direct}와, 약한 쪽 레그의 스테이킹 보상에 대한 등급별 이율을 받습니다. 추천 보상과 출금한 원금은 최고 활성 스테이킹의 {cap} 한도에 포함됩니다. 보상과 청구에는 스테이킹이 필요합니다.',
  'docs.treasuryH': '트레저리와 바이백',
  'docs.treasuryP': '본드 대금과 수수료는 프로젝트 멀티시그가 관리하는 트레저리에 쌓입니다. 30분 평균 가격이 7일 고점보다 크게 떨어지면, 트레저리는 PancakeSwap에서 한도 내로 SYN을 되사서 소각합니다.',
  'docs.feesH': '수수료',
  'docs.action': '작업',
  'docs.feeCol': '수수료',
  'docs.feeBond': '본드',
  'docs.feeStake': '스테이킹 입금',
  'docs.feeUnstake': '언스테이킹·출금·스테이킹 보상 청구',
  'docs.feeSwap': 'SYN 스왑·전송',
  'docs.feeSwapV': '세금 0% (풀 수수료만)',
  'docs.ranksH': '등급',
  'docs.rankCol': '등급',
  'docs.threshold': '팀 볼륨',
  'docs.perSide': '각 쪽',
  'docs.rateCol': '바이너리 이율',
  'docs.risksH': '위험',
  'docs.risk1': 'SYN 가격은 떨어질 수 있습니다. 보상은 SYN으로 지급되므로 그 가치도 함께 움직입니다.',
  'docs.risk2': '보상을 위한 신규 발행은 공급량을 늘립니다. 이율은 조정 가능하며 보장되지 않습니다.',
  'docs.risk3': '스마트 컨트랙트에는 버그가 있을 수 있습니다. 잃어도 괜찮은 금액만 사용하세요.',
  'docs.risk4': '지갑에서 모든 거래(네트워크, 토큰, 승인 대상, 수량)를 확인하세요. 시드 문구는 절대 공유하지 마세요.',
  'docs.risk5': '이 사이트의 내용은 투자 조언이 아닙니다. 암호자산과 추천 프로그램에 관한 현지 규정이 적용될 수 있습니다.',
  'docs.contractsH': '컨트랙트',
  'docs.contract': '컨트랙트',
  'docs.address': '주소',
  'admin.eyebrow': '거버넌스',
  'admin.title': '프로토콜 관리',
  'admin.roleNote': '변경은 {delay} 타임락을 거칩니다. 관리자 지갑이 예약하고, 대기 시간이 지나면 실행합니다. 일시 중지는 즉시 적용됩니다.',
  'admin.youProposer': '이 지갑은 관리자입니다. 변경을 예약·실행하고 컨트랙트를 일시 중지할 수 있습니다.',
  'admin.notProposer': '이 지갑은 관리자가 아닙니다. 여기서 변경을 예약·실행하려면 MetaMask(또는 다른 지갑)에서 관리자 지갑을 연결하세요.',
  'admin.staking': '스테이킹',
  'admin.bonds': '본드',
  'admin.referral': '추천',
  'admin.mint': '발행 예산 (12시간 에포크당)',
  'admin.buyback': '바이백',
  'admin.oracle': '오라클',
  'admin.paused': '일시정지',
  'admin.active': '운영 중',
  'admin.available': '현재 사용 가능',
  'admin.propose': '변경 준비',
  'admin.action': '변경 항목',
  'admin.actRates': '스테이킹 이율',
  'admin.actMarket': '본드 마켓',
  'admin.actBuyback': '바이백 설정',
  'admin.actUnpause': '모듈 재개',
  'admin.market': '마켓',
  'admin.enabled': '활성',
  'admin.roiMin': 'ROI 최소 (%)',
  'admin.roiMax': 'ROI 최대 (%)',
  'admin.capacity': '기간당 용량 (SYN)',
  'admin.trigger': '7일 고점 대비 하락 트리거 (%)',
  'admin.maxTrade': '회당 최대 (USDT)',
  'admin.maxDay': '일일 최대 (USDT)',
  'admin.slip': '슬리피지 (%)',
  'admin.cooldownH': '쿨다운 (시간)',
  'admin.burn': '되산 SYN 소각',
  'admin.module': '모듈',
  'admin.target': '대상',
  'admin.calldata': '콜데이터',
  'admin.schedule': '타임락으로 예약',
  'admin.copyJson': 'Safe Transaction Builder JSON 복사',
  'admin.copied': '복사됨',
  'admin.queue': '타임락 대기열',
  'admin.noQueue': '예약된 작업이 없습니다.',
  'admin.op': '작업',
  'admin.eta': '실행 가능 시각',
  'admin.state': '상태',
  'admin.waiting': '대기 중',
  'admin.ready': '실행 가능',
  'admin.done': '완료',
  'admin.cancelled': '취소됨',
  'admin.execute': '실행',
  'admin.emergency': '긴급 정지',
  'admin.emergencyNote': '일시정지는 신규 입금·본드·연결·추천 보상 청구를 멈춥니다. 출금과 본드 청구는 항상 가능합니다. 재개는 타임락을 거칩니다.',
  'admin.pause': '{module} 정지',
  'admin.pauseSafeOnly': '이 컨트랙트들은 관리자 지갑만 일시 중지할 수 있습니다. 이 지갑으로는 상태를 확인할 수 있습니다.',
  'admin.wallets': '관리자 지갑:',
  'admin.actAddAdmin': '관리자 지갑 추가',
  'admin.actRemoveAdmin': '관리자 지갑 삭제',
  'admin.wallet': '지갑 주소',
  'admin.walletInvalid': '지갑 주소(0x 뒤에 40자)를 입력하세요.',
  'admin.walletAlready': '이 지갑은 이미 관리자입니다.',
  'admin.walletNotAdmin': '이 지갑은 관리자가 아닙니다.',
  'admin.walletLast': '관리자 지갑이 이것 하나뿐입니다. 먼저 다른 관리자를 추가하세요. 그렇지 않으면 아무도 변경할 수 없게 됩니다.',
  'admin.addAdminNote': '실행 후 이 지갑은 MetaMask 등 어떤 지갑에서든 변경을 예약·실행하고 컨트랙트를 일시 중지할 수 있습니다.',
  'admin.removeAdminNote': '실행 후 이 지갑은 더 이상 예약·실행·일시 중지를 할 수 없습니다.',
  'admin.moreCalls': '외 {n}건',
  'admin.needAdmin': '관리자 지갑이 필요합니다',
  'dash.activity': '최근 활동',
  'dash.noActivity': '아직 활동이 없습니다.',
  'dash.activityNeedsIndexer': '활동 기록에는 인덱서가 필요합니다 (VITE_INDEXER_URL 설정).',
  'act.stake': '스테이킹',
  'act.bind': '추천인 연결',
  'act.bond': '본드 구매',
  'act.bond_claim': '본드 청구',
  'act.referral_claim': '추천 보상 청구',
  'page.dashboard.sub': '스테이킹. 리베이스. 성장.',
  'page.stake.sub': '6가지 플랜, 모두 12시간마다 복리.',
  'page.bond.sub': '시장가보다 싸게 SYN 구매, 7일 후 잠금 해제.',
  'page.swap.sub': 'PancakeSwap에서 SYN, USDT, BNB 거래.',
  'page.liquidity.sub': 'SYN과 USDT를 페어링하고 LP를 본드하세요.',
  'page.referral.sub': '바이너리 팀의 양쪽 레그를 키우세요.',
  'page.docs.sub': 'Syntra 작동 방식을 쉽게 설명합니다.',
  'page.admin.sub': '파라미터, 타임락, 긴급 제어.',
  'side.active': '활성',
  'side.epoch': '에포크',
  'side.endsIn': '종료까지',
  'social.soon': '링크 준비 중',
  'wallet.connected': '연결됨',
  'price.label': 'SYN 가격',
  'price.twap': '30분 평균',
  'notes.title': '알림',
  'notes.nextRebase': '에포크 {n} 리베이스까지',
  'notes.rate': '에포크당 이율 (잠금 없음 ~ 영구)',
  'notes.empty': '아직 지갑 활동이 없습니다.',
  'dash2.balance': 'sSYN 잔액',
  'dash2.staked': '스테이킹 잔액',
  'dash2.allStaked': '전체 보유자 스테이킹',
  'dash2.growth': '리베이스 성장',
  'dash2.thisEpoch': '지난 에포크 +{pct}',
  'dash2.nextEpoch': '다음 리베이스 +{pct}',
  'dash2.apy': 'APY',
  'dash2.apyInfo': '영구 잠금 플랜을 현재 지급 이율(보통은 플랜 이율, 보상 예산이 부족하면 그 이하)로 12시간마다 복리 운용한 경우입니다. 수익을 약속하지 않습니다.',
  'dash2.currentApy': '영구 잠금 APY',
  'dash2.rateOfMax': '에포크당 {rate} (최대 {max})',
  'dash2.binaryRate': '바이너리 {rate}',
  'dash2.needTotal': '팀 볼륨 {amount} 더',
  'dash2.needWeaker': '작은 레그에 {amount} 더',
  'dash2.stillNeeded': '남은 조건: {needs}.',
  'dash2.reqMet': '두 조건을 모두 충족했습니다. 팀의 다음 활동 때 새 랭크가 적용됩니다.',
  'dash2.topRank': '{rank} 달성 · 바이너리 {rate}',
  'dash2.rankConnect': '지갑을 연결하면 다음 추천 랭크까지의 진행률이 표시됩니다.',
  'dash2.overview': '리베이스 개요',
  'dash2.overviewInfo': '기간 동안 리베이스로 인한 1 sSYN의 성장.',
  'dash2.projectedNote': '현재 수익률 기준 예측: 아직 리베이스 기록이 없습니다.',
  'dash2.epochN': '에포크 +{n}',
  'dash2.rebases': '리베이스',
  'dash2.inPeriod': '이 기간',
  'dash2.avgRebase': '평균 리베이스',
  'dash2.perEpoch': '에포크당',
  'dash2.projection': '보상 예측',
  'dash2.projectionInfo': '현재 수익률 기준 리베이스 수익. 수익률은 바뀔 수 있으며 보장이 아닙니다.',
  'dash2.days': '{n}일',
  'dash2.day': '{n}일차',
  'dash2.example': '잠금 없이 1,000 SYN 기준',
  'dash2.allocation': '스테이킹 배분',
  'dash2.allocationInfo': '내 SYN: 스테이크, 지갑 보유, 예치금 위의 복리 보상.',
  'dash2.allocationAllInfo': '전체 SYN: 잠금 플랜, 잠금 없음, 미스테이크.',
  'dash2.stakedShort': '스테이킹',
  'dash2.available': '사용 가능',
  'dash2.rewards': '보상',
  'dash2.locked': '잠금',
  'dash2.unstaked': '미스테이킹',
  'dash2.ofSupply': '공급량 스테이킹',
  'dash2.stakeMore': 'SYN 추가 스테이킹',
  'dash2.period': '예측 기간',
  'dash2.orbLabel': '스테이크 {staked} sSYN · 다음 리베이스까지 {pct} 진행 · 공급량의 {share} 스테이크 · 에포크당 보상 {rate}',
  'dash2.rebasing': '12시간마다 리베이스',
  'dash2.nextRebase': '다음 리베이스',
  'dash2.index': 'sSYN 인덱스',
  'dash2.nextUnlock': '다음 잠금 해제',
  'dash2.allUnlocked': '해제됨',
  'dash2.noLocks': '잠금 입금 없음',
  'dash2.stakedSupply': '공급량 스테이킹',
  'dash2.perDay': '하루',
  'dash2.atRate': '현재 수익률 기준',
  'dash2.periodYield': '기간 수익률',
  'dash2.onStake': '스테이킹 금액 대비',
  'dash2.totalStaked': '총 스테이킹',
  'dash2.lockedPlusFlex': '모든 플랜의 sSYN',
  'dash2.stakedValue': '스테이킹 가치',
  'dash2.atTwap': '30분 평균 가격 기준',
  'dash2.mintedLastN': '전체 스테이커 SYN · 최근 {n} 에포크',
  'dash2.mintedNextN': '전체 스테이커 SYN · 현재 수익률로 다음 {n} 에포크',
  'stake.compounding': '에포크마다 복리',
  'bond.insight': '{asset} 마켓',
  'bond.openNow': '운영 중',
  'bond.marketPrice': '시장 가격',
  'bond.capLeft': '이번 기간 남은 판매 한도',
  'bond.roiBand': '링은 이 마켓의 ROI 상한 {max} 대비 비율입니다. ROI는 본드 판매와 부채 감소에 따라 {min}~{max} 사이에서 움직입니다.',
  'swap.priceChart': 'SYN 가격',
  'swap.priceRange': '가격 기간',
  'swap.noHistory': '가격 기록은 풀 거래에 따라 1시간 단위로 쌓입니다.',
  'swap.noIndexer': '가격 기록을 보려면 인덱서를 연결하세요.',
  'swap.priceNote': 'SYN-USDT 풀의 종가입니다. 거래가 없는 시간에는 직전 가격이 유지됩니다.',
  'liq.ownership': '풀 보유 구성',
  'liq.treasury': '트레저리 (프로토콜 보유)',
  'liq.you': '나',
  'liq.others': '기타 보유자',
  'liq.yourShare': '나의 지분',
  'liq.polShort': '프로토콜 보유',
  'liq.tvlSub': '양쪽을 풀 가격으로 평가',
  'liq.locked': '잠김(초기 유동성)',
  'liq.lockedShort': '잠김',
  'liq.lockedUntil': '풀의 {pct}는 초기 유동성이며 {date}까지 잠겨 있습니다. 이후에는 관리 지갑으로만 갈 수 있습니다.',
  'liq.lockContract': '잠금 컨트랙트',
  'ref.yourRank': '나의 랭크',
  'ref.nextRate': '다음: {rank} · {rate}',
  'ref.toNext': '다음 랭크까지',
  'ref.topRankShort': '최고 랭크',
  'ref.legs': '레그별 활성 금액',
  'ref.weakerShare': '약한 레그가 전체 금액의 {pct}를 차지합니다.',
  'ref.rankConnect': '지갑을 연결하면 랭크와 트리의 양쪽 레그를 볼 수 있습니다.',
  'ref.earnTitle': '보상 방식',
  'ref.earnDirect': '직접 보너스',
  'ref.earnDirectP': '내가 초대한 모든 사람의 스테이킹 보상의 {pct}.',
  'ref.earnBinary': '바이너리 보상',
  'ref.earnBinaryP': '약한 레그의 수익에 랭크별 {min}~{max} 비율이 적용됩니다.',
  'ref.earnCap': '보상 한도',
  'ref.earnCapP': '보상과 인출한 원금의 합은 최고 활성 스테이크의 {pct}에서 멈춥니다.',
  'testnet.pill': 'BSC 테스트넷',
  'testnet.text': '테스트 자금만 사용하며 실제 가치는 없습니다. 버튼을 누르면 수수료용 테스트 BNB와 테스트 USDT 1,000개가 전송됩니다. 테스트 BNB 추가:',
  'testnet.faucet': 'BNB Chain 파우셋',
  'testnet.mint': '테스트 BNB + USDT 1,000개 받기',
  'testnet.mintOnchain': '테스트 USDT 1,000개 받기',
  'testnet.sending': '전송 중…',
  'testnet.sent': '수수료용 테스트 BNB와 테스트 USDT 1,000개를 보냈습니다.',
  'testnet.sentUsdt': '테스트 USDT 1,000개를 보냈습니다 (수수료용 BNB는 이미 있습니다).',
  'testnet.sentNoBnb': '테스트 USDT 1,000개를 보냈습니다. 지금은 파우셋의 테스트 BNB가 부족하니 BNB Chain 파우셋을 이용하세요.',
  'testnet.cooldown': '이 지갑은 이미 테스트 자금을 받았습니다. {time} 후에 다시 시도하세요.',
  'testnet.limit': '파우셋이 지금 한도에 도달했습니다. {time} 후에 다시 시도하세요.',
  'testnet.failed': '지금은 파우셋에서 보낼 수 없습니다. 1분 후에 다시 시도하세요.',
  'plan.0': '잠금 없음',
  'plan.1': '30일 잠금',
  'plan.2': '90일 잠금',
  'plan.3': '180일 잠금',
  'plan.4': '365일 잠금',
  'plan.5': '영구 잠금',
  'plan.apy': 'APY {pct}',
  'plan.lockNone': '언제든 출금 가능',
  'plan.lockDays': '{days}일 잠금',
  'plan.featured': '최고 금리',
  'plan.featuredNoFees': '최고 금리 · 수수료 없음',
  'plan.lockForever': '원금 영구 잠금',
  'plan.fees': '수수료 입금 {in} · 출금 {out}',
  'plan.noFees': '입금·출금 수수료 없음',
  'stake.feeNone': '스테이킹 수수료',
  'stake.noFee': '없음',
  'stake.exitFeePermanentFree': '원금은 출금 불가. 보상은 수수료 없이 출금',
  'stake.youReceiveNoFee': '수수료 없이 {amount} SYN을 받습니다',
  'plan.anytime': '언제든',
  'plan.never': '없음 (보상은 언제든)',
  'plan.aboutLocked': '{days}일 동안 잠그고 더 높은 이율로 12시간마다 복리로 늘어납니다. 잠금이 끝나면 출금할 수 있으며 잠금 없음 이율로 계속 복리가 적용됩니다.',
  'plan.aboutPermanent': '가장 높은 이율입니다. 원금은 영구히 잠기며, 그 위의 보상은 12시간마다 복리로 늘어나고 언제든 출금할 수 있습니다.',
  'plan.about0': '잠금 없는 sSYN입니다. 12시간마다 복리로 늘어나며 언제든 출금할 수 있습니다. 스왑 페이지의 SYN ↔ sSYN 변환과 같습니다.',
  'stake.choose': '플랜 선택',
  'stake.form': '스테이크 · {plan}',
  'stake.claimRewards': '보상 받기',
  'stake.noRewardsYet': '아직 보상이 없습니다',
  'stake.lockEnded': '잠금 종료',
  'stake.endedRate': '잠금 없음 이율로 복리 적용 중',
  'stake.projectionSwitch': '{days}일 잠금 이후에는 잠금 없음 이율로 계산합니다. 현재 이율 기준의 추정이며 수익을 약속하지 않습니다.',
  'stake.exitFeePermanent': '원금은 출금 불가. 보상 출금 시 {pct}',
  'convert.flip': '방향 바꾸기: {to} → {from}',
  'convert.title': 'SYN ↔ sSYN 변환',
  'convert.from': '변환할 수량 ({token})',
  'convert.to': '받는 수량 ({token})',
  'convert.rate': '비율',
  'convert.rateValue': '1 : 1 ({pct} 세금 차감)',
  'convert.tax': '변환세 ({pct})',
  'convert.earns': 'sSYN 수익',
  'convert.earnsValue': 'APR {apr} · APY {apy} (12시간마다 복리)',
  'convert.about': 'sSYN은 잠금 없이 스테이크된 SYN입니다. 12시간마다 늘어나고 언제든 다시 변환할 수 있습니다. 세금은 트레저리로 가며 풀을 거치지 않습니다.',
  'convert.ctaIn': 'sSYN으로 변환',
  'convert.ctaOut': 'SYN으로 변환',
  'swap.mode': '모드',
  'swap.nativeCoin': '네이티브 코인',
  'swap.modeSwap': 'PancakeSwap',
  'dash.apyPermanent': 'APY · 영구 잠금',
  'dash.apyNoLock': 'APY · 잠금 없음',
  'dash.stakedAll': '스테이크 (sSYN, 전체 플랜)',
  'dash2.noLockApy': '잠금 없음 {apy}',
  'dash2.noLock': '잠금 없음',
  'dash2.lockedPlans': '30·90·180·365일 및 영구 플랜의 sSYN',
  'dash2.anytime': 'sSYN, 언제든 출금 가능',
  'docs.feePlans': '잠금 없음 {noLock} · 30/90/180/365일 잠금 {locked} · 영구 {perm}',
  'admin.actFees': '스테이킹 수수료',
  'admin.planApr': '{plan}: APR (%)',
  'admin.feeNoLockIn': '잠금 없음: 입금 수수료 (%)',
  'admin.feeNoLockOut': '잠금 없음: 출금 수수료 (%)',
  'admin.feeLockedIn': '잠금 플랜: 입금 수수료 (%)',
  'admin.feeLockedOut': '잠금 플랜: 출금 수수료 (%)',
  'admin.feePermanentIn': '영구 잠금: 입금 수수료 (%)',
  'admin.feePermanentOut': '영구 잠금: 보상 출금 수수료 (%)',
  'act.withdraw': '출금',
  'act.claim_rewards': '보상 수령',
  'stake.unlocksIn': '잠금 해제까지',
  'stake.permanentNote': '원금 영구 잠금 · 보상은 언제든',
  'stake.endedOn': '{date} 잠금 종료',
  'err.ZeroAmount': '0보다 큰 금액을 입력하세요.',
  'err.RebaseBacklog': '최근 {n}개 에포크의 보상이 아직 지급되지 않아, 새 스테이크는 그 처리 후에 가능합니다. 아래 「따라잡기」를 누르거나 키퍼의 처리를 기다린 뒤 다시 시도하세요.',
  'err.LotLocked': '이 포지션은 {date}까지 잠겨 있습니다. 그 이후에 출금할 수 있습니다.',
  'err.LotEmpty': '이 포지션은 이미 전액 출금되었습니다.',
  'err.InsufficientStake': '이 포지션의 보유량을 초과합니다. 출금 가능한 금액은 {available} SYN입니다. 금액을 줄이거나 「최대」를 누르세요.',
  'err.PermanentPrincipal': '영구 스테이크의 원금은 출금할 수 없고 보상만 가능합니다. 현재 {available} SYN입니다. 그 이하로 입력하세요.',
  'err.UnknownPlan': '그 플랜은 존재하지 않습니다. 페이지를 새로 고치고 플랜을 다시 선택하세요.',
  'err.NothingToClaim': '아직 청구할 보상이 없습니다. 추천 보상은 팀이 스테이크하는 동안 12시간마다 쌓입니다.',
  'err.NotEligible': '먼저 SYN을 스테이크하세요. 추천 보상은 활성 스테이크가 있는 동안에만 지급됩니다.',
  'err.AlreadyBound': '이 지갑은 이미 팀에 속해 있습니다. 추천인은 변경할 수 없습니다.',
  'err.SponsorNotBound': '그 추천인은 아직 가입하지 않아 그 아래로 가입할 수 없습니다. 먼저 가입하도록 요청하세요.',
  'err.SelfReferral': '자기 자신을 추천인으로 할 수 없습니다.',
  'err.PlacementTooDeep': '팀의 그쪽은 지금 너무 길어 배치할 수 없습니다. 반대쪽으로 가입하거나 추천인에게 라인 복구를 요청하세요.',
  'err.MarketClosed': '이 본드 시장은 현재 닫혀 있습니다. 다른 시장을 선택하거나 나중에 다시 시도하세요.',
  'err.UnknownMarket': '그 본드 시장은 존재하지 않습니다. 페이지를 새로 고치세요.',
  'err.CapacityExceeded': '이 시장에 이번 기간 남은 수량은 {left} SYN인데 이 본드는 {payout} SYN이 됩니다. 금액을 줄이거나 다음 기간을 기다리세요.',
  'err.MaxPayoutExceeded': '본드 1건으로 살 수 있는 최대는 {max} SYN인데 이 본드는 {payout} SYN이 됩니다. 금액을 줄이거나 나누어 구매하세요.',
  'err.SlippageExceeded': '확인하는 동안 가격이 움직였습니다. 이 본드는 {payout} SYN을 지급하는데, 수락한 {min} SYN보다 적습니다. 견적을 새로 고치고 다시 시도하세요.',
  'err.ValueMismatch': '보낸 BNB가 입력한 금액과 다릅니다. 페이지를 새로 고치고 다시 시도하세요.',
  'err.NotOwner': '이 본드는 다른 지갑의 것입니다.',
  'err.AlreadyClaimed': '이 본드는 이미 청구되었습니다.',
  'err.StillVesting': '이 본드는 구매 7일 후인 {date}에 잠금 해제됩니다. 그때 다시 오세요.',
  'err.PriceDeviation': '본드가 잠시 중지되었습니다. 풀 가격(${spot})이 30분 평균(${twap})에서 {dev}% 떨어져 있습니다. 가격 조작을 막기 위해 본드는 두 값의 차이가 {max}% 이내일 때만 열립니다. 평균이 따라잡으면 자동으로 다시 열립니다(보통 30분 이내).',
  'err.OracleNotReady': '가격 오라클이 첫 30분의 기록을 모으는 중입니다. 잠시 후 다시 시도하세요.',
  'err.StalePrice': '가격 피드가 {age} 동안 갱신되지 않아 이 자산을 지금 안전하게 평가할 수 없습니다. 피드가 갱신되면 바로 다시 열립니다. 다른 자산에는 영향이 없습니다.',
  'err.InvalidPrice': '가격 피드가 잘못된 값을 반환했습니다. 잠시 후 다시 시도하거나 다른 자산을 사용하세요.',
  'err.StablecoinDepeg': 'USDT가 안전 범위 밖인 ${price}에 거래되고 있어 돌아올 때까지 가격 평가를 중지합니다. 잃는 것은 없습니다. 나중에 다시 시도하세요.',
  'err.UnsupportedAsset': '그 자산은 여기서 평가할 수 없습니다.',
  'err.MinterBudgetExceeded': '이번 에포크의 보상 예산을 모두 사용했습니다(남은 {available} SYN). 12시간마다 다시 채워집니다. 다음 에포크에 시도하세요.',
  'err.GlobalBudgetExceeded': '프로토콜 전체의 이번 에포크 보상 예산을 모두 사용했습니다(남은 {available} SYN). 12시간마다 다시 채워집니다. 다음 에포크에 시도하세요.',
  'err.MinterDisabled': '이 컨트랙트의 발행이 현재 꺼져 있습니다. 잃는 것은 없습니다. 나중에 다시 시도하세요.',
  'err.EnforcedPause': '이 작업은 프로토콜 관리자가 일시 중지했습니다. 출금과 청구는 계속 가능하며, 새 예치는 해제 후 다시 할 수 있습니다.',
  'err.AccessControlUnauthorizedAccount': '이 지갑에는 그 작업에 필요한 권한이 없습니다.',
  'err.TimelockUnexpectedOperationState': '타임락이 거부했습니다. 변경이 아직 실행 가능하지 않거나, 이미 실행되었거나, 취소되었습니다. 대기열을 확인하세요.',
  'err.TimelockUnauthorizedCaller': '관리자 지갑만 변경을 예약하거나 실행할 수 있습니다.',
  'err.ERC20InsufficientBalance': '토큰이 부족합니다. 필요 {needed}, 지갑 잔액 {have}입니다.',
  'err.ERC20InsufficientAllowance': '이 금액은 아직 컨트랙트에 승인되지 않았습니다. 먼저 승인한 뒤 다시 시도하세요.',
  'err.NonTransferable': 'sSYN은 전송할 수 없습니다. 스테이킹 잔액이기 때문입니다. 대신 스테이크 페이지에서 출금하세요.',
  'err.StillLocked': '초기 유동성은 {date}까지 잠겨 있습니다.',
  'err.CooldownActive': '바이백은 {date}까지 쿨다운 중입니다.',
  'err.group.setting': '컨트랙트가 그 설정을 거부했습니다({name}). 값을 확인하고 다시 시도하세요.',
  'err.group.timelock': '타임락이 거부했습니다({name}). 대기열과 지연 시간을 확인하고 다시 시도하세요.',
  'err.group.token': '토큰 전송에 실패했습니다({name}). 금액과 잔액을 확인하고 다시 시도하세요.',
  'err.group.internal': '컨트랙트가 호출을 거부했습니다({name}). 페이지를 새로 고치고 다시 시도하세요. 계속되면 팀에 알려주세요.',
  'err.group.lock': '유동성 잠금이 거부했습니다({name}). 관리 지갑만 변경할 수 있으며, 기한은 연장만 가능합니다.',
  'err.group.buyback': '바이백이 거부했습니다({name}). 트리거, 쿨다운, 일일 한도 안에서만 실행됩니다.',
  'err.group.upgrade': '업그레이드가 거부되었습니다({name}). 구현 주소와 그것이 UUPS 컨트랙트인지 확인하세요.',
  'err.group.signature': '서명이 거부되었습니다({name}). 토큰을 소유한 지갑으로 다시 서명하세요.',
  'err.unknown': '컨트랙트가 요청을 거부했습니다({name}). 페이지를 새로 고치고 다시 시도하세요.',
  'err.noGas': '네트워크 수수료를 낼 BNB가 지갑에 부족합니다. BNB를 조금 추가하고 다시 시도하세요.',
  'err.walletGeneric': '지갑이 요청을 완료하지 못했습니다. 잠금을 해제하고 다시 시도하세요.',
  'err.wallet.4001': '지갑에서 요청을 거부했습니다.',
  'err.wallet.4100': '지갑이 아직 이 사이트를 허용하지 않았습니다. 잠금을 해제하고 다시 시도하세요.',
  'err.wallet.4200': '사용 중인 지갑은 이 요청을 지원하지 않습니다.',
  'err.wallet.4900': '지갑이 네트워크에서 연결 해제되었습니다. 확인하고 다시 시도하세요.',
  'err.wallet.4901': '지갑이 이 네트워크에 연결되어 있지 않습니다.',
  'err.wallet.4902': '지갑에 BNB Smart Chain을 추가한 뒤 다시 시도하세요.',
  'err.wallet.-32002': '지갑에 대기 중인 요청이 있습니다. 먼저 지갑을 열어 승인하거나 닫으세요.',
  'err.wallet.-32603': '지갑이 내부 오류를 보고했습니다. 잠금을 해제하고 페이지를 새로 고친 뒤 다시 시도하세요.',
  'epoch.behindTitle': '최근 {n}개 에포크의 보상이 지급을 기다리고 있습니다.',
  'epoch.behindBody': '처리가 끝나면 스테이크와 SYN → sSYN 변환이 다시 시작됩니다. 누구나 실행할 수 있으며 네트워크 수수료만 듭니다.',
  'epoch.catchUp': '따라잡기',
  'epoch.progress': '{total}개 에포크 중 {done}개 처리됨…',
  'epoch.caughtUp': '모든 에포크가 지급되었습니다. 다시 스테이크할 수 있습니다.',
  'common.fee': '네트워크 수수료 ≈ {amount} BNB',
  'docs.refCode': '초대 코드는 지갑 주소에서 생성되는 8자입니다. 두 지갑이 같은 코드를 갖게 되는 경우 먼저 가입한 지갑이 코드를 유지하며, 다른 지갑은 지갑 주소로 초대합니다.',
  'news.title': '새로운 소식',
  'news.fee': '모든 작업 버튼 아래에 확인 전 네트워크 수수료가 표시됩니다. 이 패널에는 변경 사항을 안내합니다.',
  'news.catchUp': '보상 에포크가 대기 중이면 모든 페이지의 바에서 「따라잡기」를 실행할 수 있고, 모든 오류가 무슨 일이 있었는지와 다음에 할 일을 알려줍니다.',
  'news.ranksLock': '랭크는 동시에 스테이킹 중인 두 레그로 계산되며, 잠금 컨트랙트가 프로젝트의 SYN-USDT 유동성을 12개월 동안 보관합니다.',
  'news.joinFirst': '초대받은 지갑은 첫 스테이크 전에 초대자의 팀에 가입하도록 안내받습니다. 언어 메뉴의 국기, 커뮤니티 링크, 그리고 어떤 관리자 지갑으로도 쓸 수 있는 관리자 페이지.',
  'news.emblems': '대시보드의 랭크 엠블럼과 다음 랭크 단계, 스왑의 토큰 메뉴와 전환 버튼, 3D 네트워크·트리·스테이킹 화면.',
  'news.plans': '6가지 스테이킹 플랜: 잠금 없음, 30·90·180·365일 잠금, 그리고 수수료 없는 영구 플랜. 초대 링크에 8자 코드.',
  'news.staking': 'SYN과 sSYN, SYN ↔ sSYN 전환을 포함한 복리 플랜, 원클릭 포싯, 모든 컨트랙트 소스를 BscScan에서 검증.',
  'news.live': 'Syntra 브랜드로 BSC 테스트넷에 공개. 영어·일본어·한국어 지원.',
  'plan.upTo': '최대',
  'plan.paying': '현재 {pct} 지급 (보상 예산)',
  'dash2.budget': '보상 예산',
  'dash2.budgetUsed': '에포크당 {cap} SYN 중 {used} SYN 사용',
  'dash2.budgetCapped': '예산이 부족합니다. 이번 에포크에는 모든 플랜이 각 이율의 {pct}를 지급합니다.',
  'dash2.rateNote': '현재 이율 기준이며, 보상 예산에 따라 낮아질 수 있습니다.',
  'docs.budgetP': '각 플랜의 APR은 최대치입니다. 보상은 에포크당 {cap} SYN의 예산에서 지급되며, 모든 플랜의 필요량이 이를 넘으면 각 플랜은 이율의 같은 비율만 지급합니다. 따라서 풀이 커질수록 실제 지급 이율은 낮아집니다. 현재 모든 플랜이 에포크당 {wanted} SYN을 필요로 합니다.',
  'err.FeeBelowRate': '거부되었습니다. 출금 가능한 플랜에서는 입출 수수료의 합이 한 에포크의 이율 이상이어야 합니다 (플랜 {plan}: 수수료 {fee} 대 이율 {rate}/에포크).',
  'news.rates': '플랜 이율이 "최대"로 표시됩니다. 보상 예산이 부족하면 카드에 현재 지급 이율이 표시되고, 대시보드에 예산 미터가 추가되었습니다.',
  'bond.reopensIn': '약 {time} 후, 평균 가격이 다음에 움직일 때 다시 열립니다. 가격이 돌아오면 더 빨리 열립니다.',
  'price.moving': '가격 변동 중: 풀 가격이 평균에서 {dev} 떨어져 있습니다.',
  'price.movingRules': '여기서는 아무것도 멈추지 않습니다. 스테이크는 두 가격 중 낮은 쪽으로 기록되고 추천 보상 청구는 높은 쪽으로 지급됩니다. 본드는 두 가격이 일치할 때까지 기다립니다.',
  'news.price': '가격이 급변해도 스테이킹과 추천 보상 청구는 멈추지 않습니다. 스테이크는 평균과 현재가 중 낮은 쪽으로 기록되고, 청구는 높은 쪽으로 지급됩니다. 본드 배너에 재개 시각이 표시되고, 스테이크와 추천 페이지에 "가격 변동 중" 표시가 추가되었습니다.',
  'gov.c.staking': '스테이킹',
  'gov.c.bonds': '본드',
  'gov.c.referral': '추천',
  'gov.c.buyback': '바이백',
  'gov.c.registry': '발행 등록부',
  'gov.c.timelock': '타임락',
  'gov.c.treasury': '트레저리',
  'gov.c.oracle': '가격 오라클',
  'gov.c.lpLock': '유동성 잠금',
  'gov.c.unknown': '컨트랙트',
  'gov.r.proposer': '관리자(제안)',
  'gov.r.executor': '관리자(실행)',
  'gov.r.canceller': '거부권(취소)',
  'gov.r.pauser': '일시정지',
  'gov.r.admin': '소유자',
  'gov.r.treasurer': '재무',
  'gov.r.keeper': '키퍼',
  'gov.r.staking': '스테이킹',
  'gov.r.stakeFor': '대리 스테이크',
  'gov.r.other': '알 수 없는',
  'gov.rates': '스테이킹 이율이 {aprs} APR로 바뀝니다 (잠금 없음 · 30 · 90 · 180 · 365일 · 영구).',
  'gov.fees': '스테이킹 수수료가 바뀝니다: 입금 {ins}, 출금 {outs}; 수수료 지갑 {recipient}.',
  'gov.maxRate': '스테이킹 최대 이율이 에포크당 {pct}로 바뀝니다.',
  'gov.referralWiring': '스테이킹이 추천 컨트랙트 {address}에 연결됩니다.',
  'gov.market': '본드 마켓 {id}: {state}, ROI {min}–{max}, 기간당 용량 {cap} SYN.',
  'gov.marketNew': '새 본드 마켓: {state}, ROI {min}–{max}, 기간당 용량 {cap} SYN.',
  'gov.open': '열림',
  'gov.closed': '닫힘',
  'gov.buyback': '바이백 설정: 7일 고점 대비 {trigger} 아래에서 발동, 거래당 {perTrade} USDT · 하루 {perDay} USDT까지, 슬리피지 {slip}, 쿨다운 {cooldown}, 매수한 SYN은 {bought}.',
  'gov.burned': '소각',
  'gov.kept': '트레저리 보관',
  'gov.minter': '{contract}의 발행 예산: 에포크당 {cap} SYN, 버스트 {n} 에포크, {state}.',
  'gov.enabled': '활성',
  'gov.disabled': '비활성',
  'gov.globalCap': '전체 발행 예산: 에포크당 {cap} SYN, 버스트 {n} 에포크.',
  'gov.referralRates': '추천 이율: 직접 {direct}; 랭크 {ranks}; 각 쪽 최소 {minSide}.',
  'gov.maxDepth': '추천 거래량이 {n}단계까지 올라갑니다.',
  'gov.capMultiplier': '추천 상한: 최고 활성 스테이크의 {pct}.',
  'gov.pause': '{contract}이(가) 일시정지됩니다.',
  'gov.unpause': '{contract}이(가) 재개됩니다.',
  'gov.upgrade': '{contract} 컨트랙트가 구현 {impl}(으)로 업그레이드됩니다.',
  'gov.roleGrant': '{account}이(가) {contract}의 {role} 역할을 얻습니다.',
  'gov.roleRevoke': '{account}이(가) {contract}의 {role} 역할을 잃습니다.',
  'gov.delay': '타임락 지연이 {time}(으)로 바뀝니다.',
  'gov.treasury': '트레저리 {fn}: {args}.',
  'gov.unknown': '{contract} 호출 {selector}.',
  'docs.upcomingH': '예정된 변경',
  'docs.upcomingNote': '프로토콜의 모든 변경은 48시간 타임락을 거칩니다. 관리자 지갑이 예약하면 지연 기간 내내 여기에 표시되고, 실행되기 전까지 거부권 지갑이 취소할 수 있습니다.',
  'docs.upcomingNone': '예정된 변경이 없습니다.',
  'docs.upcomingAt': '{date}부터 실행 가능',
  'docs.upcomingReady': '지금 실행 가능',
  'docs.upcomingAfter': '작업 {id} 이후',
  'notes.change': '예정된 변경',
  'notes.changeDone': '실행된 변경',
  'admin.actAddVeto': '거부권 지갑 추가',
  'admin.actRemoveVeto': '거부권 지갑 제거',
  'admin.vetoNote': '거부권 지갑은 예정된 변경을 취소하는 것만 할 수 있습니다. 프로토콜을 운영하지 않는 하드웨어 지갑에 보관하세요. 48시간 동안 악의적인 변경을 막을 수 있는 유일한 키입니다.',
  'admin.removeVetoNote': '실행 후 이 지갑은 예정된 변경을 더 이상 취소할 수 없습니다.',
  'admin.vetoAlready': '이 지갑은 이미 거부권을 갖고 있습니다.',
  'admin.vetoNotVeto': '이 지갑은 거부권이 없습니다.',
  'admin.vetoWallets': '거부권 지갑:',
  'admin.noVeto': '아직 거부권 지갑이 없습니다. 도난당한 키로 예약된 악의적인 변경을 막을 수 있는 것은 관리자 지갑뿐입니다. 취소 권한만 가진 콜드 지갑을 추가하세요.',
  'admin.youCanceller': '이 지갑은 거부권을 갖고 있습니다. 아래 대기열에서 예정된 변경을 취소할 수 있습니다.',
  'admin.actUpgrade': '컨트랙트 업그레이드',
  'admin.proxy': '컨트랙트',
  'admin.implementation': '새 구현 주소',
  'admin.implInvalid': '구현 주소를 입력하세요 (0x 뒤 40자).',
  'admin.implChecking': '구현을 확인하는 중…',
  'admin.implNotUups': '이 주소는 UUPS 구현이 아닙니다 (proxiableUUID 확인 실패).',
  'admin.implOk': 'UUPS 구현입니다. 예약 전에 검증된 소스를 검토하세요.',
  'admin.implSource': 'BscScan의 소스',
  'admin.upgradeNote': '실행되면 프록시는 저장소를 그대로 둔 채 새 구현으로 동작합니다. 먼저 포크에서 리허설하세요 (npm run contracts:rehearsal).',
  'admin.cancel': '취소',
  'admin.cancelNote': '취소하면 작업이 영구히 제거됩니다. 나중에 다시 예약할 수 있습니다.',
  'news.rates2': '새 스테이킹 이율: 365일 잠금은 APR 250%, 영구 플랜은 APR 365%입니다. 변경은 48시간 타임락을 거쳐 적용되며, 그때까지 "예정된 변경"에 표시됩니다.',
  'news.gov': '예정된 모든 변경이 이 페이지의 "예정된 변경"과 알림 벨에 쉬운 말과 실행 시각과 함께 표시됩니다. 관리자는 취소만 할 수 있는 거부권 지갑을 추가하고, 관리자 페이지에서 컨트랙트 업그레이드를 예약할 수 있습니다.',
};
